import { CashDesk } from './cash-desk';
import { InvoicePoint } from './invoice-point';
import { CashDeskOpen } from './cash-desk-open';
import { ServiceFilter } from './service-filter';

export class CashDeskUserOpen {
  public Services: ServiceFilter[];
  public InvoicePoints: InvoicePoint[];
  public Service: ServiceFilter;
  public InvoicePoint: InvoicePoint;
  public CashDeskOpen: CashDeskOpen;
  public CashDesk: CashDesk;
  public CashDeskInvoicePointId: number;
  public InvoicePointSelectByService: boolean;
}
